import { InjectionToken } from '@angular/core';

export interface SharedAppConfig {
    frontend: {
        appBasePath: string;
    };
    knowledgeBase: {
        maxLength: number;
    };
    backend: {
        baseUrl: string | Record<string, string>;
        requestHeaders?: Record<string, string> | Record<string, Record<string, string>>;
    };
}

export const SHARED_APP_CONFIG_TOKEN = new InjectionToken<SharedAppConfig>('Shared App Configuration Token');
